import React from 'react';

import { School } from 'app/types';
import Text from 'common/components/Text/Text';
import { AttributeComponent } from './Overview';

import styles from 'features/explore/school/SchoolDetail.module.scss';
import { useMediaQuery } from 'react-responsive';

interface CompProps {
  school?: School;
  comesFromExplore?: boolean;
}

export const InternationalStudentsComponent = ({
  school,
  comesFromExplore,
}: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className={styles.sectionContainer}>
      {comesFromExplore ? (
        <h4 className={styles.subtitle}>Is it good for international student?</h4>
      ) : (
        <h3 className={styles.subtitle}>Is it good for international student?</h3>
      )}
      <div className="d-flex flex-row align-items-center mt-4 gap-4">
        {school?.international_student_rate && (
          <AttributeComponent
            attribute="International student rate"
            value={school?.international_student_rate}
          />
        )}
        {school?.number_of_students && (
          <AttributeComponent
            attribute="Total student number"
            value={school?.number_of_students.toLocaleString('en-US')}
          />
        )}
      </div>
      <Text size={16} weight={400} inlineStyle={{ color: '#19234F' }}>
        {school?.international_student_description}
      </Text>
    </div>
  );
};
